<template>
    <div id="tablePrint">
        <b-table
            show-empty
            responsive
            :items="reportInvoice.listReportInvoice"
            :fields="fields"
            :per-page="search.perPage"
            :busy="search.isLoading"
            class="scroll-bar-pop text-center"
            empty-text="ไม่มีรายการออกใบแจ้งหนี้"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
            foot-clone
        >         
            <div slot="HEAD_total_net_price" slot-scope="row">
                        {{row.label}} 
                <i 
                    class="fas fa-info-circle fa-xs text-primary cursor-pointer" 
                    v-b-tooltip
                    title='นิติบุคคลหักภาษี ณ ที่จ่าย จากค่าขนส่ง 1% และค่าบริการ 3%'>
                </i>
            </div>
            <div slot="table-busy" class="text-center">
                <div class="text-center text-primary my-2">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <strong> Loading...</strong>
                </div>
            </div>
            <template slot="index" slot-scope="data">
                {{ getOverAllIndex( data.index ) }}
            </template>
            <template slot="created_at" slot-scope="row">
                {{ row.item.created_at | dateFormat }}
            </template>
            <template slot="updated_at" slot-scope="row">
                {{ row.item.updated_at | dateFormat }}
            </template>
            <template slot="sa_code" slot-scope="row">
                {{ (row.item.sa_code) ? row.item.sa_code : '-' }}
            </template>
            <template slot="invoice_no" slot-scope="row">
                 <a class="a-tag color-tag" @click="getInvoiceAndReceipt(row.item , 'invoice')">{{row.item.invoice_no}}</a> 
            </template>
             <template slot="receipt_no" slot-scope="row">
                 <a class="a-tag color-tag" @click="getInvoiceAndReceipt(row.item , 'receipt')">{{row.item.receipt_no}}</a> 
            </template>
            <template slot="total_courier_cost" slot-scope="row">
                {{ row.item.total_courier_cost | numFormat('0,0.00') }}
            </template>
            <template slot="total_additional_fuel_charge" slot-scope="row">
                {{ row.item.total_additional_fuel_charge | numFormat('0,0.00') }}
            </template>
            <template slot="total_service" slot-scope="row">
                {{ row.item.total_service | numFormat('0,0.00') }}
            </template>
            <template slot="vat_price" slot-scope="row">
                {{ row.item.vat_price | numFormat('0,0.00') }}
            </template>
            <template slot="total_service_exclude_vat" slot-scope="row">
                {{ row.item.total_service_exclude_vat | numFormat('0,0.00') }}
            </template>
            <template slot="total" slot-scope="row">
                {{ row.item.total | numFormat('0,0.00') }}
            </template>
            <template slot="total_courier_cost_wht" slot-scope="row">
                {{ row.item.total_courier_cost_wht | numFormat('0,0.00') }}
            </template>
            <template slot="total_service_exclude_vat_wht" slot-scope="row">
                {{ row.item.total_service_exclude_vat_wht | numFormat('0,0.00') }}
            </template>
            <template slot="total_net_price" slot-scope="row">
                {{ row.item.total_net_price | numFormat('0,0.00') }}
            </template>
            <template slot="status" slot-scope="row">
                <span :class="statusInvoice( row.item.status ).color">
                    {{ statusInvoice( row.item.status ).status }}
                </span>
            </template>
            <template slot="manage" slot-scope="row">
                <template v-if="$USER_LOGIN.get().isShippop">
                    <b-button variant="success" size="sm" :disabled="row.item.status == 'PAID'" @click="checkWalletPay(row.item)">
                        <span class="px-2">
                            ชำระเงินแล้ว
                        </span>
                    </b-button>
                </template>
                <template v-else-if="$USER_LOGIN.get().isAdmin">
                    <b-button variant="warning" size="sm" @click="checkWalletPay(row.item)" v-if="row.item.status == 'UNPAID'">
                        <span class="px-2">
                            <i class="fas fa-money-bill-alt"></i> 
                            {{ ($WALLET.available_balance >= row.item.total || $WALLET.available_balance >= row.item.total_net_price ) 
                            ? 'ชำระเงิน' : 'เติมเงิน'}}
                        </span>
                    </b-button>
                </template>
                <b-button variant="primary" size="sm" @click="getReportInvoice(row.item)">
                    <span class="px-2">
                        <Icon icon="mdi-tray-arrow-up" /> รายการทั้งหมด
                    </span>
                </b-button>
            </template>
            <template slot="FOOT_index">{{(typeInvoiceMySelf) ? '' : 'รวม'}}</template>
            <template slot="FOOT_sa_code"> &nbsp;</template>
            <template slot="FOOT_sale_name"> &nbsp;</template>
            <template slot="FOOT_shop_code"> &nbsp;</template>
            <template slot="FOOT_created_at"> &nbsp;</template>
            <template slot="FOOT_invoice_no"> &nbsp;</template>
            <template slot="FOOT_receipt_no"> &nbsp;</template>
            <template slot="FOOT_shop_name">สรุปยอด:</template>
            <template slot="FOOT_order_total">{{reportInvoice.listTotalInvoice.orders}}</template>
            <template slot="FOOT_total_courier_cost">{{reportInvoice.listTotalInvoice.courier_cost | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_additional_fuel_charge">{{reportInvoice.listTotalInvoice.additional_fuel_charge | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_service">{{reportInvoice.listTotalInvoice.service | numFormat('0,0.00') }}</template>
            <template slot="FOOT_vat_price">{{reportInvoice.listTotalInvoice.vat_price | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_service_exclude_vat">{{reportInvoice.listTotalInvoice.service_exclude_vat | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total">{{(typeInvoiceMySelf) ? 'รวม:' : '' }} {{reportInvoice.listTotalInvoice.total | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_courier_cost_wht">{{reportInvoice.listTotalInvoice.courier_cost_wht | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_service_exclude_vat_wht">{{reportInvoice.listTotalInvoice.service_exclude_vat_wht | numFormat('0,0.00') }}</template>
            <template slot="FOOT_total_net_price">{{reportInvoice.listTotalInvoice.net_price | numFormat('0,0.00') }}</template>
            <template slot="FOOT_receipt_amount">{{reportInvoice.listTotalInvoice.total_receipt_amount | numFormat('0,0.00') }}</template>
            <template slot="FOOT_updated_at"> &nbsp;</template>
            <template slot="FOOT_manage"> &nbsp;</template>
            <template slot="FOOT_status"> &nbsp;</template>
        </b-table>
        <div class="mt-3">
            <b-pagination 
                :total-rows="search.totalItem"
                :current-page="search.page"
                :per-page="search.perPage"
                :value="search.page" 
                @input="changePage"
                align="right">
            </b-pagination>
        </div> 
    </div>
</template>

<script>
import moment from 'moment'
import { fieldExport } from '@/components/custom/reportInvoice/fieldExcelInvoice'
import { getPDFReportInvoiceAndReceipt, getReportInvoiceS3 } from '@/axios/invoice'
import { statusInvoice } from "@/plugins/statusInvoice"
import { showErrorModal } from "@/components/modalNotification.js";
const DATE_NOW = moment().format("YYYY-MM-DD")

export default {
    props:{
        search: Object,
        type: String,
        reportInvoice: Object
    },
    data(){
        return { 
            statusInvoice: statusInvoice
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    methods:{
        getOverAllIndex(index){
            return ( this.search.page * 25 ) - 25 + index + 1
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.$emit('getReport');
        },
        getInvoiceAndReceipt( item , type ){
            this.reportInvoice.busy = true
            getPDFReportInvoiceAndReceipt( item.id , type ).then( response => {
                window.open( response.data.url , '_blank');
                this.reportInvoice.busy = false
            }).catch( error => {
                showErrorModal( error )
                this.reportInvoice.busy = false
            })
        },
        checkWalletPay( item ){
            this.reportInvoice.modalPay.show = true
            this.reportInvoice.modalPay.invoice = item
        },
        getReportInvoice( item ){
            this.reportInvoice.busy = true
            getReportInvoiceS3(item.id).then( res => {
                let url = res.data.url;
                if(url){
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `${item.invoice_no}-${DATE_NOW}.xlsx`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }else{
                    showErrorModal( 'ไม่มีข้อมูล' )
                }
                this.reportInvoice.busy = false
            }).catch( error => {
                console.log(error)
                showErrorModal( error )
                this.reportInvoice.busy = false
            })
        }
    },
    computed:{
        typeInvoiceMySelf(){
            return this.type === "INVOICE_SELF"
        },
        fields(){ 
            return fieldExport[this.type];
        }
    }
}
</script>